import { useState, useEffect } from 'react';
import ListView from '../../components/general/listview/ListView';
import TopBar from '../../components/general/topbar/TopBar';
import IconButton from '../../components/specific/iconbutton/IconButton';
import SearchInput from '../../components/specific/searchinput/SearchInput';
import Filter from '../../assets/images/mini/filter.png';
import { database } from '../../firebase/Firebase';
import Footer from '../../components/general/footer/Footer';
import './style.css';
import ListItemProducto from '../../components/specific/li-producto/ListItemProducto';
import { get, orderByChild, query, ref, startAfter } from 'firebase/database';
import Loading from '../../components/general/loading/Loading';
import AdvancedFilter from '../../components/general/advancedfilter/AdvancedFilter';
import LoadMoreButton from '../../components/specific/loadmore/LoadMoreButton';
import useSaveData from '../../utils/useSaveData';
import { nameCompareAZ } from '../../utils/FilterUtils';
import { useParams } from 'react-router-dom';

export default function Productos() {

  let { rubro } = useParams();

  const [json, setJson] = useSaveData(rubro, null);
  const [search, setSearch] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [scannerShow, setScannerShow] = useState(false);
  const [maxItems, setMaxItems] = useState(25);

  //Si ya hay informacion en el json utiliza esa info
  const jsonList = json == null ? [] : JSON.parse(json);
  
  const [filterList, setFilterList] = useState(jsonList);
  const [productList, setProductList] = useState(jsonList);

  useEffect(() => {
    document.title = "Productos ("+rubro.toLocaleUpperCase()+")";
    if(maxItems == 25){window.scroll(0,0);}

    const trying = query(ref(database, "productos"), orderByChild("stock"), startAfter(0));

    if(json == null){
      let list = [];
      const patern = new RegExp(rubro, 'i');
      get(trying).then((snapshot) => {
        if(snapshot.exists()) {
          snapshot.forEach((childSnap) => {
              var data = childSnap.val()
              data.key = childSnap.key;
              if(data.stock > 0 && data.nombre != null && data.nombre.match(patern) != null && (data.idRubro == 2 || data.idRubro == 4) && data.idSubrubro != 13){
                list = [data, ...list];
              }
          })
          setJson(list);
          setProductList(list.sort(nameCompareAZ));
          setFilterList(list.sort(nameCompareAZ));
        }
      }).catch((error) => {
        console.error(error);
      })
    }
    

/*
    //Solo productos con Stock y que sean de rubro insumo, repuesto o herramienta
    if(json == null){
      //console.log("Cargando productos")
      let list = [];
      get(child(test, "productos")).then((snapshot) => {
          if(snapshot.exists()) {
          snapshot.forEach((childSnap) => {
              var data = childSnap.val()
              data.key = childSnap.key;
              if(data.stock > 0 && (data.idRubro == 2 || data.idRubro == 4) && data.idSubrubro > 13){
                list = [data, ...list];
              }
          })
          setJson(list);
          setProductList(list.sort(nameCompareAZ));
          setFilterList(list.sort(nameCompareAZ));
          }
      }).catch((error) => {
          console.error(error);
      })
    }*/
  });

  const test = ref(database);

  let pat = new RegExp(search, 'i');
  let itemCount = 0;

  const filteredList = filterList.map((item) => {
    if(json != null){
      if(search.startsWith(".") && search.length > 1){
        const sid = search.replace(".", "");
        const id = item.id + "";
        if(id.startsWith(sid) && itemCount < maxItems){
          itemCount++;
          return <ListItemProducto key={item.id} item={item}/>
        }
      }else if(search.startsWith("code=") && search.length > 5 && item.codigo !== "" && item.codigo != null){
        const sid = search.replace("code=", "");
        const code = item.codigo + "";
        if(code.match(sid) != null && itemCount < maxItems){
          itemCount++;
          return <ListItemProducto item={item}/>
        }else if(sid.match(code) != null && itemCount < maxItems){
          itemCount++;
          return <ListItemProducto key={item.id} item={item}/>
        }
      }else{
        if(item.nombre.match(pat) !== null && itemCount < maxItems){
          itemCount++;
          return <ListItemProducto key={item.id} item={item}/>
        }else if(search === "" && itemCount < maxItems){
          return <ListItemProducto key={item.id} item={item}/>
        }else if(search === null && itemCount < maxItems){
          return <ListItemProducto key={item.id} item={item}/>
        }else{
          return null;
        }
      }
    }else{
      return null;
    }
    
  });


  return (
    <div className="Productos">
        <TopBar />
        <AdvancedFilter list={productList} setList={setFilterList} active={filterShow} setActive={setFilterShow} />
        <div className='productos-search'>
           <SearchInput onChange={setSearch}/>
           <div className='filters'>
              <IconButton image={Filter} onClick={() => !scannerShow && setFilterShow(!filterShow)}/>
           </div>
        </div>
        <div className='productos-display'>
          <ListView>
            {productList.length === 0 && <Loading />}
            {productList.length > 0 && filteredList}
            {productList.length > 0 && filteredList.length == 0 && "No se han encontrado resultados"}
            {productList.length > maxItems && filteredList != null && search === "" && <LoadMoreButton onClick={() => setMaxItems(maxItems + 35)}/>}
          </ListView>
        </div>
        <Footer />
    </div>
  )
}